var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/login/close.png';
import _imports_1 from '@/assets/images/logo.png';
import _imports_2 from '@/assets/images/login/select.png';
var _hoisted_1 = { class: "login_phone flexColumn-alc" };
var _hoisted_2 = { class: "lp_form flexColumn-alc flex-jcc flex1" };
var _hoisted_3 = {
    class: "flexColumn",
    style: { "width": "100%" }
};
var _hoisted_4 = { class: "flexColumn lpf_avatar" };
var _hoisted_5 = { class: "flexRow-alc" };
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["src"];
var _hoisted_8 = {
    key: 0,
    src: _imports_2,
    class: "lpfa_select"
};
var _hoisted_9 = { class: "lpf_btn" };
import { reactive, ref, onMounted } from 'vue';
import request from '@/api/request';
import feedback from '@/utils/feedback';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_info',
    emits: ['close'],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var emits = __emit;
        var store = useStore();
        onMounted(function () {
            var _a;
            if ((_a = store.state.userInfo) === null || _a === void 0 ? void 0 : _a.id) {
                Object.keys(form).forEach(function (key) {
                    if (key in store.state.userInfo) {
                        form[key] = store.state.userInfo[key] || '';
                    }
                });
                if (!form.avatar)
                    form.avatar = avatar_list[0];
            }
        });
        var loading = ref(false);
        var avatar_list = reactive([
            "https://ppt-1320245968.cos.ap-guangzhou.myqcloud.com/mouse/20241217/202412171734431989267.png",
            "https://ppt-1320245968.cos.ap-guangzhou.myqcloud.com/mouse/20241217/202412171734431989270.png",
        ]);
        var form = reactive({
            nickname: '',
            avatar: avatar_list[0],
            sex: 1
        });
        var editUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var params, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!form.nickname)
                            return [2 /*return*/, feedback.msgWarning('请填写昵称')];
                        loading.value = true;
                        params = JSON.parse(JSON.stringify(form));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, request.put('/app-api/member/user/update', params)];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        loading.value = false;
                        if ((res === null || res === void 0 ? void 0 : res.code) !== 0)
                            return [2 /*return*/];
                        store.dispatch('getUserInfo');
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        emits('close');
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _component_el_input = _resolveComponent("el-input");
            var _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "lp_close clickable",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('close')); })
                }, _cache[2] || (_cache[2] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                ])),
                _cache[6] || (_cache[6] = _createElementVNode("aside", { class: "flexColumn-alc flex-jcc lp_title" }, [
                    _createElementVNode("img", { src: _imports_1 }),
                    _createElementVNode("span", { class: "ft20 ftBold" }, "登录成功")
                ], -1)),
                _createElementVNode("aside", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "lpf_name" }, "昵称", -1)),
                        _createVNode(_component_el_input, {
                            modelValue: form.nickname,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.nickname) = $event); }),
                            style: { "width": "100%" },
                            placeholder: "请填写昵称",
                            maxlength: "20"
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "lpf_name" }, "头像", -1)),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatar_list, function (item, index) {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "lpfa_box clickable",
                                    key: index,
                                    onClick: function ($event) { return (form.avatar = item); }
                                }, [
                                    _createElementVNode("img", {
                                        src: item,
                                        class: "lpfa_img"
                                    }, null, 8, _hoisted_7),
                                    (item === form.avatar)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_6));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_button, {
                            type: "primary",
                            disabled: !form.nickname,
                            loading: loading.value,
                            onClick: editUser
                        }, {
                            default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                _createTextVNode("确认")
                            ]); }),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ])
            ]));
        };
    }
});
